/**
 * @author: Yaochao
 * @date: 2021-07-01 17:25
 * @description：input相关公众方法
 */

/**
 * 封装的input组件value值变化更改state的方法
 * @param setValue useState方法返回的函数
 * @returns {valueChange[]}
 */
export const useInputValue = (setValue) => {
    const inputValueChange = (e) => {
        setValue(e.target.value);
    };

    return [inputValueChange];
};

/**
 * 输入框enter点击事件
 * @param keyDownCallback enter点击回调方法
 * @returns {onKeyDown[]}
 */
export const userInputOnKeyDown = (keyDownCallback) => {
    const onKeyDown = (e) => {
        if (e.keyCode == 13 && keyDownCallback) {
            keyDownCallback();
        }
    };

    return [onKeyDown]
};